import StatementComponent, { Description } from '@components/Statement';
import { RouterLink, ListItem } from './styled';
import { useTracking } from 'react-tracking';
import { Grid, Heading, Bones } from '@simplywallst/ui-core';
import { SlideContent } from '../styled';

type StatementValue = 'Pass' | 'Fail' | 'No data' | 'UnInitialised';

interface Statement {
  name: string;
  title: string;
  description: string;
  context: Record<string, string>;
  value: StatementValue;
  question: string;
}

const hasDescription = [
  'IsDividendYieldTopTier',
  'IsReturnOnAssetsBetterThanIndustry',
  'IsExpectedAnnualProfitGrowthHigh',
];

const getSortedStatementKeys = (
  keys: string[],
  entities: Record<string, Statement>
) => {
  return keys
    .filter((n) => typeof entities[n] !== 'undefined')
    .sort((_a, b) => (entities[b].value === 'Pass' ? 0 : -1));
};

interface Props {
  title: string;
  isFetching?: boolean;
  statementKeys?: string[];
  statements?: Record<string, Statement>;
  canonicalUrl?: string;
}

const StatementsSlide = ({
  title,
  isFetching = true,
  statements = {},
  statementKeys = [],
  canonicalUrl = '',
}: Props) => {
  const { trackEvent } = useTracking();
  return (
    <SlideContent
      as="section"
      templateRows="auto auto"
      alignContent="space-between"
    >
      <Grid rowGap="8px" alignContent="start">
        <Heading as="h3" typography="xSmall" color="whiteRGBA" opacity={0.5}>
          {title}
        </Heading>
        {isFetching ? (
          <div>
            <Bones maxWidth="90%" marginTop="x0_5" marginBottom="x2" />
            <Bones maxWidth="85%" marginTop="x0_5" marginBottom="x2" />
            <Bones maxWidth="78%" marginTop="x0_5" marginBottom="x2" />
            <Bones maxWidth="89%" marginTop="x0_5" marginBottom="x2" />
            <Bones maxWidth="92%" marginTop="x0_5" marginBottom="x2" />
            <Bones maxWidth="75%" marginTop="x0_5" marginBottom="x2" />
          </div>
        ) : (
          <ul>
            {getSortedStatementKeys(statementKeys, statements).map((n) => {
              return (
                <ListItem key={statements[n].name}>
                  <StatementComponent
                    title={statements[n].title}
                    description={
                      hasDescription.includes(statements[n].name) && (
                        <Description statement={statements[n]} />
                      )
                    }
                    value={statements[n].value}
                    size="small"
                  />
                </ListItem>
              );
            })}
          </ul>
        )}
      </Grid>
      {canonicalUrl.length > 0 && (
        <RouterLink
          styleType="loudLarge"
          display="block"
          to={canonicalUrl}
          onClick={() => {
            trackEvent({
              type: 'track',
              modifier: 'See Full Stock Report',
              action: 'click',
            });
          }}
        >
          See Full Stock Report
        </RouterLink>
      )}
    </SlideContent>
  );
};

export default StatementsSlide;
